import { useState, useEffect } from "react";
import { useCompanyStore } from "../../state/useCompanyStore";

const usePaymentLinkInfo = () => {
  const [buttonText, setButtonText] = useState("Activate payment link");
  const { company: user } = useCompanyStore();

  useEffect(() => {
    const validatedBankExists = user.bankAccounts?.some(
      (account: { isValidated: boolean }) => account.isValidated,
    );

    if (validatedBankExists && user.isVerified) {
      setButtonText("Proceed to copy payment link");
    } else {
      setButtonText("Activate payment link");
    }
  }, [user]);

  return { buttonText };
};

export default usePaymentLinkInfo;
